<template>
  <Tour
    name="driveTour"
    :callbacks="callbacks"
    :enabled="enabled"
    :options="options"
    :steps="applicableSteps"
  />
</template>

<script>
import Tour from "./Tour";

export default {
  name: "drive-tour",
  components: { Tour },
  props: {
    enabled: Boolean
  },
  data() {
    return {
      callbacks: {
        onStop: () => {
          this.$store.dispatch("hideDriveTour");
        }
      },
      steps: [
        {
          target: ".ride",
          header: {
            title: "You Are Here"
          },
          content: `This shows where you are on Sunset Blvd. Use the arrow keys or scroll to drive up and down the street.`,
          params: {
            placement: "top"
          },
          mobile: true
        },
        {
          target: ".YearPicker",
          header: {
            title: "Select Year"
          },
          content: `Click the year to change the active photoshoot. Choose from five decades of images!`,
          params: {
            placement: "right-start"
          },
          mobile: true
        },
        {
          target: ".addYear",
          header: {
            title: "Add Another Year"
          },
          content: `Click to view multiple years side by side.`,
          params: {
            placement: "right-start"
          }
        },
        {
          target: ".FlipButton",
          header: {
            title: "Street Flip"
          },
          content: `Click to swap which side of the street is on top and which is on bottom.`,
          params: {
            placement: "left-start"
          },
          mobile: true
        },
        {
          target: ".search",
          header: {
            title: "Search for Location"
          },
          content: "Find specific destinations on or near Sunset Blvd.",
          params: {
            placement: "left-start"
          },
          before: () =>
            new Promise(resolve => {
              this.disableImageClick();
              resolve();
            }),
          mobile: true
        },
        {
          target: ".canvas.top .center-image",
          header: {
            title: "View Image"
          },
          content: "Click on any image in a row to see it up close.",
          params: {
            placement: "bottom"
          },
          before: () =>
            new Promise(resolve => {
              this.enableImageClick();
              resolve();
            }),
          mobile: true
        },
        {
          target: ".inset-button",
          header: {
            title: "Map Overview"
          },
          content:
            "Get a big-picture look at where you are in Los Angeles and on Sunset Blvd.",
          params: {
            placement: "bottom"
          },
          before: () =>
            new Promise(resolve => {
              this.disableImageClick();
              resolve();
            })
        },
        {
          target: ".BookViewToggle-container",
          header: {
            title: "Toggle View"
          },
          content:
            "Use a map to navigate each row of photos or switch to a more streamlined view.",
          params: {
            placement: "bottom"
          },
          before: () =>
            new Promise(resolve => {
              this.disableImageClick();
              resolve();
            })
        }
      ],
      options: {
        highlight: true
      }
    };
  },
  computed: {
    applicableSteps() {
      let steps = this.steps;
      if (this.$store.state.isMobile) {
        steps = steps.filter(step => step.mobile === true);
      }
      return steps;
    },
    mapViewCanvas() {
      return document.querySelector(".map-view canvas");
    }
  },
  methods: {
    disableImageClick() {
      this.mapViewCanvas.style.pointerEvents = null;
    },
    enableImageClick() {
      this.mapViewCanvas.style.pointerEvents = "all";
    }
  }
};
</script>

<style lang="scss">
.v-tour--active .fullscreen.modal {
  pointer-events: all;
}
</style>
